import { getUseCasesForTab, reorderUseCases, getTabForUseCase } from '../utils/filterUtils';
import { ANALYTICS_SUITE_TAB_IDS } from '../types/navigation';
import { buildAnalyticsSuitePath, getAnalyticsSuiteFilters, getAnalyticsSuiteTabConfig } from '../utils/navigationUtils';
import { useSelector } from 'react-redux';
import { useCallback, useMemo } from 'react';
import { getGatesAndScopes } from '../../selectors/gatesSelector';
import { useHistory, useParams, useLocation } from 'react-router-dom';
export const useAnalyticsSuiteNavigation = () => {
  const history = useHistory();
  const location = useLocation();
  const {
    gates,
    scopes
  } = useSelector(getGatesAndScopes);
  const tabConfig = useMemo(() => getAnalyticsSuiteTabConfig(gates, scopes), [gates, scopes]);
  const accessibleTabIds = useMemo(() => {
    return tabConfig.filter(config => config.accessProperties.accessAllowed).map(config => config.tabId);
  }, [tabConfig]);
  const searchParams = useMemo(() => {
    return new URLSearchParams(location.search);
  }, [location.search]);
  const {
    tabId
  } = useParams();
  const activeTabId = useMemo(() => {
    return tabId || ANALYTICS_SUITE_TAB_IDS.DISCOVER;
  }, [tabId]);
  const filters = useMemo(() => {
    return getAnalyticsSuiteFilters(searchParams);
  }, [searchParams]);
  const selectedUseCaseId = filters.useCase;
  const visibleUseCases = useMemo(() => {
    const useCases = getUseCasesForTab(activeTabId, selectedUseCaseId);

    // filter out use cases for inaccessible suites
    if (activeTabId === ANALYTICS_SUITE_TAB_IDS.DISCOVER) {
      const filteredUseCases = useCases.filter(useCase => {
        const useCaseTabId = getTabForUseCase(useCase.id);
        return accessibleTabIds.includes(useCaseTabId);
      });
      return reorderUseCases(filteredUseCases, selectedUseCaseId);
    }
    return selectedUseCaseId ? reorderUseCases(useCases, selectedUseCaseId) : useCases;
  }, [activeTabId, selectedUseCaseId, accessibleTabIds]);
  const {
    useCase: currentUseCase,
    type,
    dataType
  } = filters;
  const navigateToTab = useCallback(newTabId => {
    const filterObject = {
      useCase: currentUseCase,
      type,
      dataType
    };
    const path = buildAnalyticsSuitePath(newTabId, filterObject);
    history.push(path);
  }, [history, currentUseCase, type, dataType]);
  const navigateToUseCase = useCallback(newUseCaseId => {
    const filterObject = {
      useCase: newUseCaseId,
      type,
      dataType
    };
    const path = buildAnalyticsSuitePath(activeTabId, filterObject);
    history.push(path);
  }, [history, type, dataType, activeTabId]);
  const clearSelectedUseCase = useCallback(() => {
    const filterObject = {
      useCase: undefined,
      type,
      dataType
    };
    const path = buildAnalyticsSuitePath(activeTabId, filterObject);
    history.push(path);
  }, [history, activeTabId, type, dataType]);
  return {
    tabConfig,
    activeTabId,
    selectedUseCaseId,
    visibleUseCases,
    navigateToTab,
    navigateToUseCase,
    clearSelectedUseCase
  };
};